import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderFr = () => {
    const isTablet = useMediaQuery('(min-width: 768px)')
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="FAITES TOURNER LA ROUE ET RECEVEZ DES TOURS GRATUITS"
            highlights={[
                { word: 'DES' },
                { word: 'TOURS' },
                { word: 'GRATUITS' },
            ]}
            breakAfterWords={
                isTablet ? ['ROUE'] : isDesktop ? ['RECEVEZ'] : ['ROUE', 'DES']
            }
            className={styles.text_header}
        />
    )
}
